export default __webpack_public_path__ + "static/media/logo-oxone.fbdea9f7.svg";